
  import * as noneRuntime$m3GagJamJzt7_45YN33yTx3RTxLvdFEkIQ8TlyF2t_45EPU from '/home/runner/work/sharkfoto-nuxt/sharkfoto-nuxt/node_modules/@nuxt/image/dist/runtime/providers/none'
  
  export const imageOptions = {
    ...{
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "none",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
},
    providers: {
        ['none']: { provider: noneRuntime$m3GagJamJzt7_45YN33yTx3RTxLvdFEkIQ8TlyF2t_45EPU, defaults: {} }
    }
  }
